import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { FooterComponent } from '../../components/footer.component/footer.component';
import { NavComponent } from '../../components/nav.component/nav.component';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';

interface TeamMember {
  name: string;
  role: string;
  bio: string;
  image: string;
}

@Component({
  selector: 'app-about-jcc.component',
  imports: [
    CommonModule,
    RouterModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    NavComponent,
    FooterComponent
  ],
  templateUrl: './about-jcc.component.html',
  styleUrl: './about-jcc.component.scss',
})
export class AboutJccComponent {
  teamMembers: TeamMember[] = [
    {
      name: 'Jonathan Long',
      role: 'CEO & Founder',
      bio: 'Visionary entrepreneur who founded JCC Development with a passion for solving everyday problems through technology. Jonathan leads strategic direction and business development.',
      image: '/jonathan.jpg'
    },
    {
      name: 'Corinne Long',
      role: 'CFO & Finance Professional',
      bio: 'Financial strategist ensuring sustainable growth and smart resource allocation. Corinne manages all financial operations and keeps the company running smoothly.',
      image: '/corinne.jpg'
    },
    {
      name: 'Carter Long',
      role: 'CTO & Lead Developer',
      bio: 'Full-stack developer passionate about creating innovative solutions and exploring new technologies. Carter architects and builds the technical infrastructure behind our apps.',
      image: '/carter.jpg'
    }
  ];

  values = [
    {
      icon: 'lightbulb',
      title: 'Innovation',
      description: 'We create unique solutions that blend practicality with fun.',
      color: 'primary'
    },
    {
      icon: 'auto_awesome',
      title: 'Quality over quantity',
      description: 'We would rather make one app feel great than five apps feel okay.',
      color: 'tertiary'
    },
    {
      icon: 'groups',
      title: 'Community',
      description: 'We build apps that bring people together and solve real problems.',
      color: 'secondary'
    },
    {
      icon: 'tune',
      title: 'Every detail matters',
      description: 'We tune each pixel, sound, and pause until the whole thing just feels right.',
      color: 'primary'
    },
    {
      icon: 'favorite',
      title: 'Fair from the start',
      description: 'A good app should not require payment to be good. Free is free, and premium is a real upgrade.',
      color: 'tertiary'
    },
    {
      icon: 'verified',
      title: 'Built to last',
      description: 'We support what we make. Our apps are not stepping stones, and our users are not exit numbers.',
      color: 'secondary'
    }
  ];
}
